import {
    GET_FLEET_DISPOSITION_LOCATION_SAVE,
    SET_FLEET_DISPOSITION_LOCATION_SAVE
} from "./FleetDispositionLocationsaveType"

const getSaveFleetDispositionLocation = (fleetdispositionLocationSave: any) => ({
    type: GET_FLEET_DISPOSITION_LOCATION_SAVE,
    fleetdispositionLocationSave
})

const setSaveFleetDispositionLocation = (fleetDispositionLocationValue: any) => ({
    type: SET_FLEET_DISPOSITION_LOCATION_SAVE,
    fleetDispositionLocationValue: fleetDispositionLocationValue
})

export {
    getSaveFleetDispositionLocation,
    setSaveFleetDispositionLocation
}